import { memo } from 'react'
import { FormattedMessage } from 'react-intl'

import { Box } from '@material-ui/core'
import { uniqueId } from 'lodash'
import PrimaryTooltip from 'app/componentV4/Tooltip/PrimaryTooltip'
import ErrorIcon2 from 'app/components/icons/ErrorIcon2'
import WarningIcon from 'app/components/icons/WarningIcon'

import useStyles from './styles'

const ErrorMessageForFields = ({ errors }) => {
  const { isRequiredFields, invalidFields } = errors

  const classes = useStyles()

  const getErrors = () => {
    const errors = []
    for (const key in invalidFields) {
      const errorMessage = invalidFields[key]
      errors.push(
        <li key={uniqueId()} className={classes.message}>
          {errorMessage}
        </li>,
      )
    }
    return errors
  }

  const tooltipContent = (
    <div className={classes.contentWrap}>
      <p className={classes.title}>
        <FormattedMessage id="subscribers.import.previewTable.row.tooltip.title" />
      </p>
      <ul>{getErrors()}</ul>
    </div>
  )
  return (
    <PrimaryTooltip
      title={tooltipContent}
      placement="top"
      interactive={true}
      classes={{ tooltip: classes.tooltip }}
    >
      <Box
        component={'span'}
        display={'flex'}
        height={'100%'}
        alignItems={'center'}
        justifyContent={'center'}
      >
        {isRequiredFields ? <ErrorIcon2 /> : <WarningIcon />}
      </Box>
    </PrimaryTooltip>
  )
}

export default memo(ErrorMessageForFields)
